<script>
import Gen from '@helper/Gen';
import Vue from 'vue';
import Croppa from 'vue-croppa';
import moment from 'moment';
import env from './env';
import VueClipboard from 'vue-clipboard2';

import "@assets/global.scss"

import "@plugins/jquery/dist/jquery.min.js"
import "@helper/general_function.js"
import "@plugins/extension.js"

moment.locale("id")
global.moment = moment

Vue.use(Croppa);
Vue.use(VueClipboard);

// Loading Overlay
import 'vue-loading-overlay/dist/vue-loading.css';
import LoadingOverlay from 'vue-loading-overlay';
let LoadingOverlayCnf = {color:"#20a0ff",loader:"bars",width:120,height:100}
Vue.use(LoadingOverlay, LoadingOverlayCnf)
Vue.component('LoadingOverlay',LoadingOverlay)

/* Link Docs : https://github.com/gilbitron/laravel-vue-pagination */
Vue.component("Pagination",()=>import("laravel-vue-pagination"))

Vue.component("VImg",()=>import("@components/VImg.vue"))
Vue.component("LoadingSpinner",()=>import("@components/LoadingSpinner.vue"))
Vue.component("ProgressBar",()=>import("@components/ProgressBar.vue"))
Vue.component("VModal",()=>import("@components/VModal.vue"))

/* Form Component */
Vue.component("VForm",()=>import("@forms/VForm.vue"))
Vue.component("Uploader",()=>import("@forms/Uploader.vue"))
Vue.component("Select2",()=>import("@forms/Select2/Select2.vue"))
Vue.component("BSTagsInput",()=>import("@forms/BSTagsInput/BSTagsInput.vue"))
Vue.component("Radio",()=>import("@forms/Radio.vue"))
Vue.component("Checkbox",()=>import("@forms/Checkbox.vue"))
Vue.component("DatePicker",()=>import("@forms/DatePicker/DatePicker.vue"))
Vue.component("IonRange",()=>import("@forms/IonRange/IonRange.vue"))
Vue.component("ImageFilter",()=>import("@forms/ImageFilter.vue"))
Vue.component("RangeSlider",()=>import("@forms/RangeSlider/RangeSlider.vue"))
Vue.component("CKEditor",()=>import("@forms/CKEditor/CKEditor.vue"))

export default {
  name:"App",
  computed:{
    LoadingOverlayCnf(){ return LoadingOverlayCnf }
  },
  mounted(){
    var self = this
    global.$ = global.jQuery
    global.Gen = Gen
    Gen.loadPlugin(env.baseUrl+"/assets/plugins/ckeditor/ckeditor.js")
    // Routing link for cloned element
    $(document).on('click','.router-link', function(e){
      e.preventDefault()
      self.$router.push({path:$(this).attr('href')})
    })
    // Resize
    $(window).bind("load resize", ()=>{
      this.$root.width = window.innerWidth > 0 ? window.innerWidth : screen.width
    })
  }
}
</script>

<template>
  <div id="app">
    <router-view/>
    <LoadingOverlay :active.sync="$root.var.loadingOverlay" v-bind="LoadingOverlayCnf"></LoadingOverlay>
  </div>
</template>